import { string, TestFunction } from 'yup';
import { ITranslations } from '../../i18n/config';

interface PasswordRequirement {
  label: ITranslations;
  error: ITranslations;
  validator: TestFunction<string | undefined>;
}

const MIN_LENGTH = 8;
const MIN_UPPERCASE = 1;
const MIN_DIGIT = 1;

export const passwordRequirements: PasswordRequirement[] = [
  {
    label: 'password.requirements.length',
    error: 'error.input.password.length',
    validator: (value) => !value || value.length >= MIN_LENGTH,
  },
  {
    label: 'password.requirements.casing',
    error: 'error.input.password.casing',
    validator: (value) => !value || RegExp(`^(.*?[A-Z]){${MIN_UPPERCASE},}`).test(value),
  },
  {
    label: 'password.requirements.digits',
    error: 'error.input.password.digits',
    validator: (value) => !value || RegExp(`^(.*?[0-9]){${MIN_DIGIT},}`).test(value),
  },
  {
    label: 'password.requirements.characters',
    error: 'error.input.password.characters',
    validator: (value) => !value || !/[@'"` ]/.test(value),
  },
];

export const passwordValidation = passwordRequirements.reduce(
  (validation, requirement) =>
    validation.test(requirement.label, requirement.error, requirement.validator),
  string(),
);
